<div class="czm-page">
  <!-- Top bar -->
  <div class="czm-topbar">
    <button class="czm-close" type="button" aria-label="Close" (click)="close()">
      <i class="bx bx-x"></i>
    </button>
    <p class="czm-title">{{ isEditMode ? 'Edit Customization' : 'Add New Customization' }}</p>
    <button class="czm-save" type="button" (click)="save()">Save</button>
  </div>

  <form [formGroup]="customizationForm" class="czm-body" (click)="openMenuIndex = null">
    <!-- Basic Info -->
    <div class="czm-card">
      <div class="czm-card-header">
        <i class="bx bx-file czm-card-icon"></i>
        <div class="czm-card-headings">
          <p class="czm-card-title">Basic Info</p>
          <p class="czm-card-sub">Provide the name and description for this customization</p>
        </div>
      </div>
      <div class="czm-field">
        <label class="czm-label" for="czm-name">Name</label>
        <input
          id="czm-name"
          class="czm-input"
          type="text"
          formControlName="name"
          placeholder="e.g. Roast Level"
          (input)="checkDuplicateName()"
        />
        @if (saveAttempted && customizationForm.get('name')?.invalid) {
          <p class="czm-error">Name is required (3–100 characters).</p>
        }
        @if (isDuplicateName) {
          <p class="czm-error">A customization with this name already exists.</p>
        }
      </div>
      <div class="czm-field">
        <label class="czm-label" for="czm-description">Description</label>
        <p class="czm-hint">Optional · Max 120 characters</p>
        <input
          id="czm-description"
          class="czm-input"
          type="text"
          formControlName="description"
          maxlength="120"
          placeholder="Describe this customization for your team..."
        />
      </div>
    </div>

    <!-- Options -->
    <div class="czm-card">
      <div class="czm-card-header">
        <i class="bx bx-list-ul czm-card-icon"></i>
        <div class="czm-card-headings">
          <p class="czm-card-title">Options</p>
          <p class="czm-card-sub">Define the available choices and their pricing</p>
        </div>
        @if (!isPosManagedEdit) {
          <button class="czm-add-option" type="button" (click)="addOption()">
            <i class="bx bx-plus"></i>
            Add Option
          </button>
        }
      </div>

      <div class="czm-options-table">
        <div class="czm-options-header">
          <div class="czm-opt-col-name">Name</div>
          <div class="czm-opt-col-price">Price</div>
          <div class="czm-opt-col-default">Pre-select/<br />Default</div>
          <div class="czm-opt-col-availability">Availability</div>
          <div class="czm-opt-col-menu"></div>
        </div>

        <div formArrayName="options">
          @for (option of getOptions.controls; track option; let i = $index) {
            <div class="czm-option-row" [formGroupName]="i">
              <div class="czm-option-main">
                <div class="czm-opt-col-name">
                  <label class="czm-label" [for]="'czm-opt-name-' + i">Name</label>
                  <input
                    [id]="'czm-opt-name-' + i"
                    class="czm-input"
                    type="text"
                    formControlName="name"
                    placeholder="New option"
                  />
                  @if (option.get('name')?.errors?.['duplicate']) {
                    <p class="czm-error">Duplicate option name.</p>
                  }
                  @if (saveAttempted && option.get('name')?.errors?.['required']) {
                    <p class="czm-error">Required.</p>
                  }
                </div>
                <div class="czm-opt-col-price">
                  <label class="czm-label" [for]="'czm-opt-price-' + i">Price</label>
                  <div
                    class="czm-price-wrap"
                    [class.czm-input-disabled]="option.get('price')?.disabled"
                  >
                    <span class="czm-price-prefix">$</span>
                    <input
                      [id]="'czm-opt-price-' + i"
                      class="czm-input czm-price-input"
                      type="number"
                      min="0"
                      step="0.01"
                      formControlName="price"
                      placeholder="0.00"
                      (keydown)="preventNegativeInput($event)"
                      (blur)="formatPrice(i)"
                    />
                  </div>
                  @if (option.get('price')?.errors?.['defaultOptionPrice']) {
                    <p class="czm-error">Pre-selected options are locked at $0.00.</p>
                  }
                </div>
                <div class="czm-opt-col-default">
                  <input
                    type="checkbox"
                    class="czm-checkbox"
                    [checked]="option.get('isChecked')?.value"
                    [disabled]="option.disabled"
                    (click)="$event.preventDefault(); onDefaultToggle(i)"
                  />
                </div>
                <div class="czm-opt-col-availability">
                  <label class="czm-label">Availability</label>
                  <button
                    type="button"
                    class="czm-availability-tag"
                    [class.czm-out-of-stock]="option.get('inStock')?.value === false"
                    [disabled]="option.disabled"
                    (click)="toggleAvailability(i)"
                  >
                    {{ option.get('inStock')?.value === false ? 'Out of stock' : 'In stock' }}
                  </button>
                </div>
                <div class="czm-opt-col-menu">
                  @if (!isPosManagedEdit) {
                    <button
                      type="button"
                      class="czm-row-menu-btn"
                      aria-label="Option menu"
                      (click)="toggleRowMenu(i, $event)"
                    >
                      <i class="bx bx-dots-horizontal-rounded"></i>
                    </button>
                    @if (openMenuIndex === i) {
                      <div class="czm-row-menu" (click)="$event.stopPropagation()">
                        <button
                          type="button"
                          class="czm-row-menu-item"
                          (click)="toggleAvailability(i)"
                        >
                          {{
                            option.get('inStock')?.value === false
                              ? 'Mark as in stock'
                              : 'Mark as out of stock'
                          }}
                        </button>
                        <button
                          type="button"
                          class="czm-row-menu-item czm-row-menu-danger"
                          (click)="removeOption(i)"
                        >
                          Remove option
                        </button>
                      </div>
                    }
                  }
                </div>
              </div>
              <div class="czm-option-description">
                <label class="czm-label" [for]="'czm-opt-desc-' + i">Description (optional)</label>
                <input
                  [id]="'czm-opt-desc-' + i"
                  class="czm-input"
                  type="text"
                  formControlName="description"
                  maxlength="300"
                  placeholder="Add a description..."
                />
              </div>
            </div>
          }
        </div>
      </div>

      @if (saveAttempted && getOptions.length === 0) {
        <p class="czm-error">Add at least one option.</p>
      }
      <p class="czm-options-hint">Add the choices customers can pick from</p>
      <p class="czm-options-note">
        Note: Pre-selected options are included in the dish by default. Customers can remove them,
        but the base price is unchanged. Price is locked at $0.00 for pre-selected options — e.g.,
        onion on a cheeseburger: removable on request, no discount when removed.
      </p>
    </div>

    <!-- Selection rules + Quantity rules -->
    <div class="czm-two-col">
      <div class="czm-card">
        <div class="czm-card-header">
          <i class="bx bx-slider-alt czm-card-icon"></i>
          <div class="czm-card-headings">
            <p class="czm-card-title">Selection rules</p>
            <p class="czm-card-sub">Control how customers interact with this customization</p>
          </div>
        </div>
        <div class="czm-rule-row">
          <p class="czm-rule-label">Require a selection</p>
          <button
            type="button"
            class="czm-toggle"
            [class.czm-toggle-on]="customizationForm.get('requireSelection')?.value"
            [disabled]="customizationForm.get('requireSelection')?.disabled"
            (click)="toggleControl('requireSelection')"
            aria-label="Require a selection"
          ></button>
        </div>
        <div class="czm-rule-row">
          <p class="czm-rule-label">Allow more than one to be selected</p>
          <button
            type="button"
            class="czm-toggle"
            [class.czm-toggle-on]="customizationForm.get('isMultiSelect')?.value"
            [disabled]="customizationForm.get('isMultiSelect')?.disabled"
            (click)="toggleControl('isMultiSelect')"
            aria-label="Allow more than one to be selected"
          ></button>
        </div>
      </div>

      <div class="czm-card" [class.czm-card-disabled]="!isMultiSelect">
        <div class="czm-card-header">
          <i class="bx bx-layer czm-card-icon"></i>
          <div class="czm-card-headings">
            <p class="czm-card-title">Quantity rules</p>
            <p class="czm-card-sub">
              Set limits on how many options customers can select
              @if (isMultiSelect) {
                <span> — up to {{ maxAllowed }} {{ maxAllowed === 1 ? 'option' : 'options' }}</span>
              }
            </p>
          </div>
        </div>
        <div class="czm-rule-row">
          <p class="czm-rule-label">Minimum selections</p>
          <input
            class="czm-input czm-qty-input"
            type="number"
            [min]="minAllowed"
            [max]="maxAllowed"
            formControlName="minSelections"
            (keydown)="preventNegativeInput($event)"
          />
        </div>
        <div class="czm-rule-row">
          <p class="czm-rule-label">Maximum selections</p>
          <input
            class="czm-input czm-qty-input"
            type="number"
            [min]="1"
            [max]="maxAllowed"
            formControlName="maxSelections"
            placeholder="No maximum"
            (keydown)="preventNegativeInput($event)"
          />
        </div>
      </div>
    </div>

    @if (ruleError) {
      <p class="czm-error czm-rule-error">{{ ruleError }}</p>
    }

    <!-- Settings -->
    <div class="czm-card">
      <div class="czm-card-header">
        <i class="bx bx-cog czm-card-icon"></i>
        <div class="czm-card-headings">
          <p class="czm-card-title">Settings</p>
          <p class="czm-card-sub">Configure pricing and visibility preferences</p>
        </div>
      </div>
      <div class="czm-rule-row">
        <div>
          <p class="czm-rule-label">Price differs for each option</p>
          <p class="czm-hint">
            Enable this to set individual prices for each option in this customization.
          </p>
        </div>
        <button
          type="button"
          class="czm-toggle"
          [class.czm-toggle-on]="customizationForm.get('priceDiffersForEachOption')?.value"
          [disabled]="customizationForm.get('priceDiffersForEachOption')?.disabled"
          (click)="toggleControl('priceDiffersForEachOption')"
          aria-label="Price differs for each option"
        ></button>
      </div>
      <div class="czm-rule-row">
        <div>
          <p class="czm-rule-label">Shown to customers</p>
          <p class="czm-hint">
            When off, this customization is hidden from customer apps. Your dashboard, POS and
            waiter app still see it.
          </p>
        </div>
        <button
          type="button"
          class="czm-toggle"
          [class.czm-toggle-on]="customizationForm.get('isCustomerVisible')?.value"
          (click)="toggleControl('isCustomerVisible')"
          aria-label="Shown to customers"
        ></button>
      </div>
    </div>

    <!-- Remarks -->
    <div class="czm-card">
      <div class="czm-card-header">
        <i class="bx bx-message-rounded czm-card-icon"></i>
        <div class="czm-card-headings">
          <p class="czm-card-title">Remarks</p>
          <p class="czm-card-sub">Add any additional notes or instructions</p>
        </div>
      </div>
      <textarea
        class="czm-input czm-remarks"
        rows="4"
        formControlName="remarks"
        placeholder="Enter the Remarks"
      ></textarea>
    </div>
  </form>
</div>
